/* eslint-disable max-len */
import { ChangeDetectorRef, Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from "ag-grid-community";
import { ShoppingCartListComponent } from '../../components/shopping-cart-list/shopping-cart-list.component';
import { event, param } from 'jquery';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { ShoppingCartService } from '../../services/shopping-cart.service';

@Component({
    selector: 'cv-qty-input-rendered',
    template: `
  <input *ngIf="!isCxOne"
        class="cxone-shopping-cart-list-input"
        [hidden]="data == null" type="number" name="" id="{{'input' + data?.ProductID + data?.Variation}}"
        class="ProductQuantity marginLeftBox"
        min="1"
        max="{{maxAllowed > 20 ? 20 : maxAllowed}}"
        value="{{cellValue}}"
        (keypress)="numberOnly($event)"
        (blur)="validateEmptyOrMaxAllowedValue($event)"
        (keyup)="validateEmptyOrMaxAllowedValue($event)"
        (input)="validateInput($event)"
        [disabled]="matchedProduct == null || (selectedVariationData != null && !selectedVariationData.Active) || isAProductModified || !hasExistencies">
`
})
export class QtyInputRenderedComponent implements ICellRendererAngularComp {

    public cellValue!: string;
    public data: any = null;
    public maxAllowed!: any;
    public minxAllowed: any = 1;
    public isQtyEmpty = false;
    public previousSelectedQty: any = null;
    public value!: any;
    public matchedProduct!: any;
    public selectedVariationData!: any;
    public rowNode!: any;
    public isCxOne = false;
    public previousValue = 1;
    public isAProductModified = false;
    public hasExistencies = true;
    public pscs: any = null;

    constructor(
        public shoppingCartListComponent: ShoppingCartListComponent,
        private cvConfigurationService: CvConfigurationService,
        private shoppingCartService: ShoppingCartService,
        private cdr: ChangeDetectorRef,
    ) {
        this.isCxOne = cvConfigurationService.isCxOne;
        this.pscs = this.shoppingCartService.shoppingCartObj;
    }

    // gets called once before the renderer is used
    agInit(params: ICellRendererParams): void {
        this.data = params.data;
        this.cellValue = this.getValueToDisplay(params);
        if (this.data != null) {
            this.initAG(params);
        }
    }

    // gets called whenever the user gets the cell to refresh
    refresh(params: ICellRendererParams) {
        // set value into cell again
        this.data = params.data;
        this.cellValue = this.getValueToDisplay(params);
        if (this.data != null) {
            this.initAG(params);
        }
        return true;
    }

    getFormatedValue(value, key, defaultValue) {
        return this.shoppingCartListComponent.cvNumberLocalize.transform(value) + ' ' + this.shoppingCartListComponent.getLocalizationString(key, defaultValue);
    }

    getValueToDisplay(params: ICellRendererParams) {
        return params.valueFormatted ? params.valueFormatted : params.value;
    }

    validateValue(event, product, index, isManualInput) {
        const inputs: any = document.getElementsByClassName("cxone-shopping-cart-list-input");
        const value = inputs[index].getElementsByClassName('numeric-selector-value')[0].value;
        //if value is not an integer:
        if (!(Number.isInteger(Number(value)) && Number(value) > 0)) {
            //if it is anything but the backspace then replace it with the previous valid value.
            if (event.keyCode != 8) {
                this.cellValue = this.previousSelectedQty;
                inputs[index].value = this.cellValue;
                this.isQtyEmpty = this.cellValue == null;
                this.pscs.shoppingCartIsQtyInputEmpty = this.isQtyEmpty;
                if (!this.isQtyEmpty)
                    this.validateInputCxone(isManualInput);
            } else {
                this.isQtyEmpty = true;
                this.pscs.shoppingCartIsQtyInputEmpty = true;
                this.cellValue = null;
                this.previousSelectedQty = null;
            }
            //the value is an integer greater than 0:
        } else {
            const maxStock = this.maxAllowed;
            //if the value entered is greater than the available stock, set the maximum stock instead.
            if (Number(value) > maxStock) {
                this.cellValue = maxStock;
                this.previousSelectedQty = maxStock;
                inputs[index].value = maxStock;
            } else {
                this.cellValue = value;
                this.previousSelectedQty = Number(this.cellValue);
                inputs[index].value = this.previousSelectedQty;
            }
            this.isQtyEmpty = false;
            this.pscs.shoppingCartIsQtyInputEmpty = false;
            this.validateInputCxone(isManualInput);
        }
    }

    checkQtyInput($event, product) {
        const inputs: any = document.getElementsByClassName("cxone-shopping-cart-list-input");
        const elementsArray = [].slice.call(inputs);
        const productIndex = elementsArray.findIndex(i => i.id == "input" + product.ProductID.toString() + product.Variation.toString());

        //Quantity changed by clicking + or - button
        if (Number.isInteger($event) && Number($event) > 0) {
            if (this.previousSelectedQty == $event) return;
            if (this.pscs.shoppingCartwasCartUpdated) {
                this.isQtyEmpty = false;
                this.pscs.shoppingCartwasCartUpdated = false;
            }
            if (this.previousSelectedQty != null && $event == this.previousSelectedQty.toString().substring(0, 1)) {
                this.validateValue($event, product, productIndex, true);
                return;
            };
            if (this.isQtyEmpty) {
                inputs[productIndex].getElementsByClassName('numeric-selector-value')[0].value = '';
                return;
            }
            else
                this.validateValue($event, product, productIndex, false);
        } else {
            //Manually entered value
            if (this.pscs.shoppingCartwasCartUpdated) {
                this.isQtyEmpty = false;
                this.previousSelectedQty = inputs[productIndex].getElementsByClassName('numeric-selector-value')[0].value;
                this.pscs.shoppingCartwasCartUpdated = false;
            }

            setTimeout(() => {
                this.validateValue($event, product, productIndex, true);
            }, 0);
        }
    }

    //Event function when we don't have the element "cxone-numeric-selector".
    async validateInputNormal(event) {
        const paramsColumn = {
            force: true,
            suppressFlash: true
        };
        if (!Number.isInteger(Number(event.target.value))) {
            this.value = this.previousValue;
            this.cellValue = this.value.toString();
            this.pscs.shoppingCartIsQtyInputEmpty = false;
            return;
        }
        //
        if (Number(event.target.value) == 0) {
            this.value = this.previousValue;
            this.cellValue = this.value.toString();
            this.pscs.shoppingCartIsQtyInputEmpty = false;
            return;
        }
        this.value = parseInt(event.target.value);
        this.rowNode.data.Quantity = this.value;
        const element: any = document.getElementById('input' + this.data.ProductID + this.data.Variation);

        if (this.selectedVariationData != null && this.selectedVariationData.VariationQuantity == null) {
            element.max = 20;
        }
        if (this.selectedVariationData == null && this.matchedProduct.Quantity == null) {
            element.max = 20;
        }
        if (this.value >= element.min && this.value <= element.max) {
            if (element.max > 20 && this.value > 20) {
                this.rowNode.data.Quantity = 20;
                element.value = this.rowNode.data.Quantity;
            }
            else {
                this.rowNode.data.Quantity = this.value;
                const result = await this.shoppingCartListComponent.updateCart(this.rowNode.data);
                this.handlerResultInput(result, paramsColumn);
            }
        } else {
            this.rowNode.data.Quantity = element.max;
            element.value = this.rowNode.data.Quantity;
            const result = await this.shoppingCartListComponent.updateCart(this.rowNode.data);
            this.handlerResultInput(result, paramsColumn);
        }
    }

    //Event function "cxone-numeric-selector".
    async validateInputCxone(isManualInput) {
        this.pscs.shoppingDisableCheckout = true;
        this.cdr.detectChanges();
        if (this.pscs.shoppingCartIsCheckingQty) return;

        const paramsColumn = {
            force: true,
            suppressFlash: true
        };

        this.value = parseInt(this.cellValue);
        this.rowNode.data.Quantity = this.value;

        if (this.isQtyEmpty) {
            this.pscs.shoppingCartIsCheckingQty = false;
            return;
        }

        if (isManualInput) {
            this.cdr.detectChanges();
            setTimeout(async () => {
                if (this.pscs.shoppingCartIsCheckingQty) return;
                if (this.isQtyEmpty) {
                    this.pscs.shoppingCartIsCheckingQty = false;
                    return;
                }
                this.pscs.shoppingCartIsCheckingQty = true;
                this.cdr.detectChanges();
                const result = await this.shoppingCartListComponent.updateCart(this.rowNode.data);
                this.handlerResultCxone(result, paramsColumn);
                this.pscs.shoppingCartwasCartUpdated = true;
                this.pscs.shoppingCartIsCheckingQty = false;
                this.pscs.shoppingDisableCheckout = false;
            }, 1000);

        } else {
            this.pscs.shoppingCartIsCheckingQty = true;
            const result = await this.shoppingCartListComponent.updateCart(this.rowNode.data);
            this.handlerResultCxone(result, paramsColumn);
            this.pscs.shoppingCartwasCartUpdated = true;
            this.pscs.shoppingCartIsCheckingQty = false;
            this.pscs.shoppingDisableCheckout = false;
        }
    }

    async validateInput(event) {
        if (this.isCxOne) {
            this.validateInputCxone(event);
        } else {
            this.validateInputNormal(event);
        }
    }

    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }

    validateEmptyOrMaxAllowedValue(event) {
        if (event.target) {
            if (event.target.value == '' || event.target.value == null) {
                if (event.keyCode != 8 && event.keyCode != 46) {
                    this.value = this.previousValue;
                    this.cellValue = this.value.toString();
                    event.target.value = this.cellValue;
                    this.pscs.shoppingCartIsQtyInputEmpty = false;
                } else {
                    this.value = '';
                    this.cellValue = this.value;
                    event.target.value = this.cellValue;
                    this.pscs.shoppingCartIsQtyInputEmpty = true;
                    return;
                }
            } else if (event.target.value >= this.minxAllowed && event.target.value <= this.maxAllowed) {
                if (this.maxAllowed > 20 && event.target.value > 20) {
                    this.previousValue = 20;
                    this.value = this.previousValue;
                    this.cellValue = this.value.toString();
                    event.target.value = this.cellValue;
                    this.pscs.shoppingCartIsQtyInputEmpty = false;
                }
            } else {
                if (event.target.value < this.minxAllowed) {
                    this.previousValue = 1;
                    this.value = this.previousValue;
                    this.cellValue = this.value.toString();
                    event.target.value = this.cellValue;
                    this.pscs.shoppingCartIsQtyInputEmpty = false;
                    if (!this.isCxOne) {
                        const element: any = document.getElementById('input' + this.data.ProductID + this.data.Variation);
                        element.value = event.target.value;
                        element.dispatchEvent(new Event("input"));
                    }
                } else if (event.target.value > this.maxAllowed) {
                    this.previousValue = this.maxAllowed > 20 ? 20 : this.maxAllowed;
                    this.value = this.previousValue;
                    this.cellValue = this.value.toString();
                    event.target.value = this.cellValue;
                    this.pscs.shoppingCartIsQtyInputEmpty = false;
                }
            }
        }
    }

    /**
     * This function is used to initiate validations and row values (quantity input).
     * @param params the current row
     */
    initAG(params: any): void {
        this.value = params.value;
        const agGrid = this.shoppingCartListComponent.agGrid ?? params;
        this.rowNode =
            this.data.Variation == null ?
                agGrid?.api.getRowNode(this.data.ProductID) :
                agGrid?.api.getRowNode(`${this.data.ProductID}${this.data.Variation}`);
        const cartProduct =
            this.shoppingCartListComponent.pscs.pointStoreCart.pointStoreProducts.find((p) => p.ProductID === this.data.ProductID);
        this.matchedProduct =
            this.shoppingCartListComponent.pscs.pointStoreProducts.find((p) => p.PointStoreProductID === this.data.ProductID);
        this.selectedVariationData = null;
        this.maxAllowed = null;
        if (this.matchedProduct != null) {
            if (this.matchedProduct.HasProductVariations) {
                this.selectedVariationData =
                    this.matchedProduct.VariationsData.find((v) => v.PointStoreProductVariationID === this.data.Variation);
                if (this.selectedVariationData != null && this.selectedVariationData.VariationQuantity != null) {
                    this.maxAllowed = parseInt(this.selectedVariationData.VariationQuantity, 10);
                } else {
                    //check if the item added to the cart had no variations and now has variations
                    if (this.data.Variation == null || this.data.Variation === 0) {
                        this.isAProductModified = true;
                    }
                }
            } else if (this.matchedProduct.Quantity != null) {
                this.maxAllowed = parseInt(cartProduct.Quantity, 10) + parseInt(this.matchedProduct.Quantity, 10);
            }
            //check if the item added to the cart had variations and now doesn't have variations
            if (!this.matchedProduct.HasProductVariations && this.data.Variation != null && this.data.Variation > 0) {
                this.isAProductModified = true;
            }
            //check the existence of the product
            this.hasExistencies = this.shoppingCartListComponent.checkProductQuantity(this.data);
        }
        this.previousValue = this.value;
        //fix: if we have products with empty quantity we couldn't increase quantity
        this.maxAllowed = this.maxAllowed == null ? 20 : this.maxAllowed;
    }

    async handlerResultCxone(responseResult: number, paramsColumn: any) {
        switch (responseResult) {
            //0 = error
            case 0:
                this.value = this.previousValue;
                this.cellValue = this.value.toString();
                this.rowNode.data.Quantity = this.value;
                this.pscs.shoppingCartIsQtyInputEmpty = false;
                break;
            //  1 = successfull
            case 1:
                this.previousValue = this.value;
                this.previousSelectedQty = this.value;
                this.shoppingCartListComponent.disabledItems = 0;
                this.shoppingCartListComponent._data = this.shoppingCartListComponent.pscs.pointStoreCart.pointStoreProducts;
                this.shoppingCartListComponent.agGrid?.api.setGridOption('rowData', this.shoppingCartListComponent._data);
                this.shoppingCartListComponent.agGrid?.api.refreshCells(paramsColumn);
                break;
            case 2:
                //2 = not enough stock
                this.value = this.previousValue;
                this.previousSelectedQty = this.value;
                this.cellValue = this.value.toString();
                this.rowNode.data.Quantity = this.value;
                this.pscs.shoppingCartIsQtyInputEmpty = false;
                await this.shoppingCartListComponent.refreshGridOnNotEnoughtStockProduct();
                this.shoppingCartListComponent.disabledItems = 0;
                this.shoppingCartListComponent._data = this.shoppingCartListComponent.pscs.pointStoreCart.pointStoreProducts;
                this.shoppingCartListComponent.agGrid?.api.setGridOption('rowData', this.shoppingCartListComponent._data);
                this.shoppingCartListComponent.agGrid?.api.refreshCells(paramsColumn);
                break;
            default:
                break;
        }
    }


    async handlerResultInput(responseResult: number, paramsColumn: any) {
        const element: any = document.getElementById('input' + this.data.ProductID + this.data.Variation);
        switch (responseResult) {
            //0 = error
            case 0:
                this.value = this.previousValue;
                this.cellValue = this.value.toString();
                this.rowNode.data.Quantity = this.value;
                element.value = this.rowNode.data.Quantity;
                this.pscs.shoppingCartIsQtyInputEmpty = false;
                break;
            //  1 = successfull
            case 1:
                this.previousValue = this.value;
                this.shoppingCartListComponent.disabledItems = 0;
                this.shoppingCartListComponent._data = this.shoppingCartListComponent.pscs.pointStoreCart.pointStoreProducts;
                this.shoppingCartListComponent.agGrid?.api.setGridOption('rowData', this.shoppingCartListComponent._data);
                this.shoppingCartListComponent.agGrid?.api.refreshCells(paramsColumn);
                break;
            case 2:
                //2 = not enough stock
                this.value = this.previousValue;
                this.cellValue = this.value.toString();
                this.rowNode.data.Quantity = this.value;
                element.value = this.rowNode.data.Quantity;
                this.pscs.shoppingCartIsQtyInputEmpty = false;
                await this.shoppingCartListComponent.refreshGridOnNotEnoughtStockProduct();
                this.shoppingCartListComponent.disabledItems = 0;
                this.shoppingCartListComponent._data = this.shoppingCartListComponent.pscs.pointStoreCart.pointStoreProducts;
                this.shoppingCartListComponent.agGrid?.api.setGridOption('rowData', this.shoppingCartListComponent._data);
                this.shoppingCartListComponent.agGrid?.api.refreshCells(paramsColumn);
                break;
            default:
                break;
        }
    }
}
